
export const TOAST_MESSAGES = {
    MESSAGES_LOAD_FAIL: "Failed to load messages",
    MESSAGE_SEND_ERROR: "Failed to send Message",
    NO_MESSAGES : "No messages yet..."
}